<template>
  <div>
    <div style="display: flex; margin-bottom: 20px; margin-left: 40px">
      <el-page-header @back="back" content="打印出库单" style="margin-right: 20px"></el-page-header>
      <button type="primary" @click="printContext">打印</button>
    </div>
    <div id="printMe" ref="print">
      <div class="printtable" style="page-break-after:always;">
        <div class="table_title">
          <img src="@/assets/images/jflogo.png" alt="" style="height:25px;position:absolute;left:25px;">
          {{organizationName}} (出库单)
        </div>
        <!-- 打印 -->
        <div>
          <div class="AMarkUl">
            <ul>
              <li>出库单号:{{ ATableData.outstockNo }}</li>
              <li>一级货主:{{ ATableData.primaryCustomerName }}</li>
              <li>二级货主:{{ ATableData.customerName }}</li>
            </ul>
            <ul>
              <li style="font-size:22px;font-weight: 700;">车牌号:{{ ATableData.outstockPlateNumber }}</li>
              <li>司机:{{ ATableData.driverName }}</li>
              <li>司机电话:{{ ATableData.telephone }}</li>
              <li>客户单号:{{ ATableData.outBillNo}}</li>
            </ul>
          </div>
          <table style="word-break:break-all;word-wrap:break-all;">
            <tbody>
              <tr>
                <td class="kunbao" style="">车船号</td>
                <td class="kunbao" style="">产地</td>
                <td class="kunbao" style="min-width:75px">货物类型</td>
                <td class="kunbao">规格</td>
                <td class="kunbao">材质</td>
                <td class="kunbao">仓位</td>
                <td class="kunbao">件数</td>
                <td class="kunbao">皮重(吨)</td>
                <td class="kunbao">毛重(吨)</td>
                <td class="kunbao">净重(吨)</td>
              </tr>
              <tr v-for="(item, index) in ATableList" :key="index">
                <td class="">{{ item.vehicleNumber }}</td>
                <td class="">{{ item.placeOfOrigin }}</td>
                <td class="">{{ item.productTypeName }}</td>
                <td class="">{{ item.specification }}</td>
                <td class="">{{ item.model }}</td>
                <td class="">{{ item.warehouseName }}</td>
                <td class="">{{ item.number }}</td>
                <td class="">{{ item.tareWeight }}</td>
                <td class="">{{ item.grossWeight }}</td>
                <td class="" v-if="!item.tareWeight&&!item.grossWeight">{{ item.allWeight }}</td>
                <td class="" v-else>{{ item.weightingWeight }}</td>
              </tr>
              <tr>
                <td>合计</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>{{numberSum}}</td>
                <!-- {{tareWeightSum}} -->
                <td></td>
                <!-- {{grossWeightSum}} -->
                <td></td>
                <td>{{weightingWeightSum}}</td>
                <!-- <td>{{weightSum}}</td> -->
                <!-- <td>{{GBweight}}</td> -->
              </tr>
              <tr>
                <td>备注</td>
                <td colspan='9' style="text-align:left">{{ATableData.remark}}</td>
              </tr>
            </tbody>
          </table>
          <div class="AMarkFoot">
            <ul>
              <li>制单员:{{ username }}</li>
              <li>保管员签字：</li>
              <li>司机签字：</li>
              <li>打印时间:{{ datenow }}</li>
            </ul>
          </div>
          <div class="remarks">
            {{showname}}
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {
  printOutstockDocumentLwg
} from '@/api/wms-access'
import {
  JfgetOutstockInfoJanFa
  , getDictionaryList
} from '@/api/wms-stock'
import DonMessage from '@/utils/message'
import { dateFormat1 } from '@/utils/util'

export default {
  data () {
    return {
      weightSum: 0,
      numberSum: 0,
      GBweight: 0,
      totalNum: 0,
      totalWeightDouble: 0,
      tareWeightSum: 0,
      grossWeightSum: 0,
      weightingWeightSum: 0,
      id: '',
      idAll: '',
      type: 0,
      getData: null,
      flag: 0,
      getFlag: false,
      ATableList: [], // 表格
      ATableData: [], // 信息
      username: '',
      datenow: '',
      showname: '本单壹式肆联：第一联单证中心，第二联现场提货司机，第三联保管员，第四联门岗出门证',
      organizationName: window.localStorage.getItem('tenantName')
    }
  },
  created () {
    // 生命周期里接收参数
    this.id = this.$route.query.id // 接受参数关键代码
    this.username = window.localStorage.getItem('userName')
    this.datenow = dateFormat1(new Date().getTime(), 'CHN-YYYY-MM-ss h-m-s')
    // this.getDictionaryLists()
  },
  mounted () {
    this.printOutstockDocumentLwgS()
  },
  methods: {
    // 打印内容
    printContext () {
      this.$print(this.$refs.print)
    },
    // 点击返回上一步
    back () {
      this.$router.go(-1) // 返回上一层
    },
    // 出库计划-主数据-打印
    printOutstockDocumentLwgS () {
      JfgetOutstockInfoJanFa({
        outstockId: this.id // 出库主表id
      })
        .then((res) => {
          this.ATableList = res.tEmptyOutstockSummaryList
          this.ATableData = res.tEmptyOutstockMaster
          this.weightSum = res.tEmptyOutstockSummaryList.reduce((pre, cur) => Number(pre / 1 + cur.allWeight / 1).toFixed(4), 0)
          this.numberSum = res.tEmptyOutstockSummaryList.reduce((pre, cur) => pre / 1 + cur.number / 1, 0)
          this.GBweight = res.tEmptyOutstockSummaryList.reduce((pre, cur) => Number(pre / 1 + cur.weighingWeight / 1).toFixed(4), 0)
          for (let index = 0; index < this.ATableList.length; index++) {
            for (let indexA = 0; indexA < res.emptyWeightInfoList.length; indexA++) {
              if (this.ATableList[index].outstockSummaryId == res.emptyWeightInfoList[indexA].summaryId) {
                this.$set(this.ATableList[index], 'grossWeight', res.emptyWeightInfoList[indexA].grossWeight)
                this.$set(this.ATableList[index], 'tareWeight', res.emptyWeightInfoList[indexA].tareWeight)
                this.$set(this.ATableList[index], 'weightingWeight', res.emptyWeightInfoList[indexA].weightingWeight)
              }
            }
          }
          let queryList = this.ATableList.filter((item) => {
            return item.tareWeight !== undefined || item.grossWeight !== undefined || item.weightingWeight !== undefined
          })
          console.log(queryList, 'queryList')
          this.tareWeightSum = queryList.reduce((pre, cur) => Number(pre / 1 + cur.tareWeight / 1).toFixed(4), 0)
          this.grossWeightSum = queryList.reduce((pre, cur) => Number(pre / 1 + cur.grossWeight / 1).toFixed(4), 0)
          // if (queryList.length == 0) {
          //   this.weightingWeightSum = this.ATableList.reduce((pre, cur) => Number(pre / 1 + cur.allWeight / 1).toFixed(4), 0)
          // } else {
          //   this.weightingWeightSum = queryList.reduce((pre, cur) => Number(pre / 1 + cur.weightingWeight / 1).toFixed(4), 0)
          // }
          this.ATableList.forEach((item, index) => {
            item.XSweight = ''
            if (!item.tareWeight || !item.grossWeight) {
              item.XSweight = item.allWeight
            } else {
              item.XSweight = item.weightingWeight
            }
          })
          this.weightingWeightSum = this.ATableList.reduce((pre, cur) => Number(pre / 1 + cur.XSweight / 1).toFixed(4), 0)
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    getDictionaryLists () {
      getDictionaryList({ tenantCode: window.localStorage.getItem('tenantCode'), groupNo: 'out_empty_remark' })
        .then(res => {
          console.log(res)
          this.showname = res[0].showName
        })
        .catch(err => {
          this.message({ message: err.message, type: 'error' })
        })
    }
  },
  filters: {
    formatDate: function (value) {
      let date = new Date(value)
      let y = date.getFullYear()
      let MM = date.getMonth() + 1
      MM = MM < 10 ? '0' + MM : MM
      let d = date.getDate()
      d = d < 10 ? '0' + d : d
      let h = date.getHours()
      h = h < 10 ? '0' + h : h
      let m = date.getMinutes()
      m = m < 10 ? '0' + m : m
      // let s = date.getSeconds()
      // s = s <script 10 ? '0' + s : s
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m
    }
  }
}
</script>

<style scoped lang='less'>
button {
  width: 100px !important;
}
#printMe {
  font-size: 19px;
  position: relative;
  padding: 10px;
  // margin-bottom: 10px;
  box-sizing: border-box;
  //   height: 500px;
  width: 100%;
  border: 1px solid #ccc;

  .table_title {
    width: 100%;
    height: 40px;
    font-size: 29px;
    text-align: center;
    font-weight: 700;
    margin: 10 0;
  }
}
.printtable {
  width: 900px;
  margin-bottom: 20px;
}
.AMarkUl {
  // font-size: 12px !important;
  width: 100%;
  font-size: 17px;
  ul {
    width: 100%;
    display: flex;
    justify-content: space-between;
    li {
      list-style: none;
      // flex: 1;
      // color: black;
    }
  }
}
.AMarkFoot {
  font-size: 17px;
  bottom: 10px;
  width: 100%;
  ul {
    width: 100%;
    display: flex;
    margin: 10 !important;
    padding: 0 !important;
    justify-content: space-between;
    li {
      list-style: none;
      // flex: 1;
      // color: black;
    }
  }
}
table,
th,
td {
  border: 1px solid blue;
}
table {
  border-collapse: collapse;
}

table,
th,
td {
  border: 1px solid black;
}
table {
  width: 100%;
  margin: 0 auto;
  margin-bottom: 10px;
  font-size: 22px;
  td {
    // width: 17%;
    // padding: 4px 4px;
    text-align: center;
    height: 24px;
  }

  .kunbao {
    font-weight: 600;
  }
}
.remarks {
  font-size: 17px;
  text-align: center;

  p {
    margin: 0;
    padding: 0;
  }
}
</style>
